import { CommonModule } from '@angular/common';
import { Component, inject, Optional } from '@angular/core';
import { I18nModule, Product } from '@spartacus/core';
import { OutletContextData } from '@spartacus/storefront';
import { map } from 'rxjs';

@Component({
  selector: 'custom-product-summary',
  templateUrl: './product-summary.component.html',
  styleUrl: './product-summary.component.scss',
  imports: [CommonModule, I18nModule],
})
export class CustomProductSummaryComponent {
  @Optional() protected productContext: OutletContextData<{
    product: Product;
  }> = inject(OutletContextData<{ product: Product }>);

  product$ = this.productContext.context$.pipe(map((context) => context.product));
}
